<template>
  <div class="container container--employee artworks employee-orders-catalog">
    <div class="row table__wrapper">
      <div class="employee__filtration col-12 mb-3">
        <div class="row">
          <div v-if="meta" class="col-sm-6">
            <span>
              {{ I18n.t('filters.show') }}
              <Filters
                :options="perPage"
                :isShowAllRecordsButtonClicked="isShowAllRecordsButtonClicked"
                @changeSelected="handleSelectChange"
                @allRecordsSelected="() => isShowAllRecordsButtonClicked = !isShowAllRecordsButtonClicked"
              />
            </span>
          </div>
          <div class="col-sm-6">
            <Pagination class="text-center" :meta="meta" />
          </div>
        </div>
      </div>
      <table class="dashboard__table">
        <thead>
          <tr>
            <th>{{I18n.t("table.number")}}</th>
            <th>
              <SortLink
                :name="'artworks.image'"
                :attribute="'catalog_number_string'"
                @changeQ="(value) => q = value"
              />
            </th>
            <th>
              <SortLink
                :name="'artworks.starting_price_without_currency'"
                :attribute="'starting_price'"
                @changeQ="(value) => q = value"
              />
            </th>
            <th>
              {{I18n.t("artworks.estimated_price")}}
            </th>
            <th>
              <SortLink
                :name="'artworks.selling_price'"
                :attribute="`${$route.params.auctionType}_auction_value`"
                @changeQ="(value) => q = value" />
            </th>
            <th class="winnerHeader">
              {{I18n.t("artworks.live_auctions.buyer")}}
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          <FinishedAuctionsCatalogArtworksRow
            v-for="(artwork, index) in artworks"
            :artwork="artwork"
            :index="index"
            :artist="artwork.artist"
            :internetAuction="artwork.internetAuction"
            :auctionsCatalog="auctionsCatalog"
            :meta="meta"
            :key="artwork.id"
            class="artwork-row" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FIRST_PAGE, DEFAULT_PER_PAGE } from '@/shared/consts';
import SortLink from '@/shared/components/sort_link';
import Pagination from '@/shared/components/pagination/index';
import Filters from '@/shared/components/filters';
import { PER_PAGE } from './../../../../consts';
import FinishedAuctionsCatalogArtworksRow from './row';

export default {
  name: 'FinishedAuctionsCatalogsArtworksList',
  components: {
    FinishedAuctionsCatalogArtworksRow,
    SortLink,
    Pagination,
    Filters,
  },
  data() {
    return {
      perPage: PER_PAGE,
      selectedPerPage: DEFAULT_PER_PAGE,
      isShowAllRecordsButtonClicked: false,
      selectedPer: DEFAULT_PER_PAGE,
      fetchTimeout: null,
      q: null,
    };
  },
  created() {
    this.fetchAuctionsCatalogArtworks();
  },
  watch: {
    filterParams() {
      const buildQuery = this.$route.query || {};
      buildQuery.page = FIRST_PAGE;
      this.$router.replace({ query: buildQuery });
      this.fetchAuctionsCatalogArtworks();
    },
    currentPage() {
      this.filterParams.page = this.currentPage.page;
      this.fetchAuctionsCatalogArtworks();
    },
    isShowAllRecordsButtonClicked(val) {
      if (val) {
        this.selectedPer = this.meta.total_count;
      } else {
        this.selectedPer = this.selectedPerPage;
      }
    },
    selectedPerPage() {
      this.selectedPer = this.selectedPerPage;
    },
  },
  computed: {
    ...mapGetters('artworks', ['auctionsCatalog', 'artworks', 'meta']),
    filterParams() {
      return {
        per: this.selectedPer,
        q: {
          s: this.q,
        },
      };
    },
    currentPage() {
      return {
        page: this.$route.query.page,
      };
    },
    isNotInternetType() {
      return this.$route.params.auctionType !== 'internet';
    },
    auctionType() {
      return this.$route.params.auctionType;
    },
    auctionsCatalogId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions('artworks', [
      'getFinishedInternetAuctionsCatalogsArtworks',
      'destroyArtwork',
    ]),
    fetchAuctionsCatalogArtworks() {
      this.filterParams.auctions_catalog_id = this.auctionsCatalogId;
      this.filterParams.auction_type = this.auctionType;
      this.getFinishedInternetAuctionsCatalogsArtworks(this.filterParams);
    },
    handleSelectChange(value) {
      this.selectedPerPage = value;
      this.isShowAllRecordsButtonClicked = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/internet/auctions/list.vue?2f7ff661